import { render } from "./GenericInput.vue?vue&type=template&id=462b1307"
import script from "./GenericInput.vue?vue&type=script&lang=js"
export * from "./GenericInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__